//import { inject } from 'aurelia-framework';
//import { DOM } from 'aurelia-pal';
//declare var System: any;
//import * as $ from "jquery";

//export class ThemeManager {

//    loadTheme(theme) {
//        this.removeOldThemes();
//        return Promise.resolve(this.theme(theme));
//    }

//    theme(theme) {
//        let themePath = this.getNormalizedThemePath(theme);
//        this.deleteFromSystemJS(themePath);

//        return System.import(themePath);
//    }

//    deleteFromSystemJS(normalizedPath) {
//        if (System.has(normalizedPath)) {
//            System.delete(normalizedPath);
//        }
//    }


//    getNormalizedThemePath(theme) {
//        return System.normalizeSync(`/vendor/ej/web/${theme}/ej.web.all.min.css!`);
//    }

//    removeOldThemes() {
//        //jQuery('head > link').each(function () {
//        //    if (this.href.includes('/vendor/ej/web')) {
//        //        DOM.removeNode(this);
//        //    }
//        //});
//    }
//}